import styled from 'styled-components'

import { ReactComponent as DotsSVG } from '@sketch/icons/dots-3-horizontal-24'

export const DotsIcon = styled(DotsSVG)`
  width: 24px;
  height: 24px;
`
